module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service_repair.repair.man_hours":"ใช้เวลาซ่อมโดยประมาณ","service_repair.field.repair_detail_rich.placeholder":"เช่น จากการตรวจสอบพบว่าแผงวงจรใช้งานปกติ แต่ตัว Connector หลวม เป็นต้น"}}')
  delete Component.options._Ctor
}
